module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAgMAAABinRfyAAAACVBMVEVMaXHc3t7c3t5Rj3EMAAAAAnRSTlMAgJsrThgAAAAsSURBVAjXFcgxAQAgDMAwpCERETxUJUuPHll7TceuPQsGg8FgMBgMBoOz9wHGoBhl9MV0/wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/filetypes/file corner.png
// module id = ./app/web/src/assets/filetypes/file corner.png
// module chunks = 0